import { render, staticRenderFns } from "./PhoneView.vue?vue&type=template&id=100140ad&scoped=true"
import script from "./PhoneView.vue?vue&type=script&lang=js"
export * from "./PhoneView.vue?vue&type=script&lang=js"
import style0 from "./PhoneView.vue?vue&type=style&index=0&id=100140ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100140ad",
  null
  
)

export default component.exports